module.exports = __webpack_public_path__ + "img/yi3.ccc3a37d.jpg";